import React from 'react';

const GenerateButton = ({ loading, disabled, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`generate-btn${loading ? ' generate-btn--loading' : ''}`}
    >
      {loading && <span className="gen-spinner" />}
      {loading ? 'Generating...' : 'Generate Documents \u2192'}
    </button>
  );
};

export default GenerateButton;
